import type { Suggestion } from '@frontend/api-types';

// Web uses the full suggestion for the label, mobile uses the shortened label
export type HomeScreenTaskSuggestion = {
  clusterLabel?: string;
  draftDescription: string;
  shortenedLabel: string;
  suggestionId: string;
};

export const mapSuggestion = (s: Suggestion): HomeScreenTaskSuggestion => ({
  clusterLabel: s.clusterLabel ?? '',
  draftDescription: s.description,
  shortenedLabel: s.title ?? '',
  suggestionId: s.id,
});
